import { LE_WITH_DIFF_EMPID_SSN } from "../constant";

//checks if passed legal entity has different member id and ssn
export const isEMpSsnDiff = (legalEntityId) => {
    return LE_WITH_DIFF_EMPID_SSN.includes(legalEntityId);
}